import React, {Fragment, useEffect} from 'react';
import {connect} from "react-redux";
import {setAbortController, setSQFTAr3dPopup} from "../../../../../actions/sqftMenuFunctions";
import ShapesGoogleModelViewer from "../../ar3d/ShapesGoogleModelViewer";
import ShapesThreeJsViewer from "../../ar3d/ShapesThreeJsViewer";
import ExportButton from "../../ar3d/ExportButton";
import SqftFeaturesPopup3dButtons from "../../../../popups/sqftFeaturesPopup/sqftFeaturesPopup3dButtons";
import SqftFeaturesPopupChangeColorButton from "../../../../popups/sqftFeaturesPopup/sqftFeaturesPopupChangeColorButton";
import SqftFeaturesPopupSaveImageButton from "../../../../popups/sqftFeaturesPopup/sqftFeaturesPopupSaveImageButton";
import MultiLoader from "../../../../ui/multiLoader";
import store from "../../../../../store";
import {setMultiLoader} from "../../../../../actions/actionFunctions";
import Config from "../../../../../config";
import GroheFeatures from "../../../../look/grohe/groheNavigation/groheFeatures/groheFeatures";
import {setLookActiveCategory, setLookOpened} from "../../../../../actions/lookFunctions";
import {setAPIErrorMessage, setSqftCabinetsGlb} from "../../../../../actions/sqftFunctions";
import {setCabinetdGLBFromCabinetsSet} from "../../../helpers/sqft3dArHelper";
import sqftShapeManager from "../../canvas/store/sqftShapeManager";
import {SHAPE_PART_ID} from "../../../constants";
import {isProd} from "../../../../../misc/fabricatorHardcode";

const ThreeDContent = (props) => {
  const {lookActiveFeature, setLookActiveCategory, apiErrorMessage, cabinetsGlb, setSQFTAr3dPopup, setLookOpened,
    abortRequestController} = props;

  useEffect(()=> {
    setLookOpened(false);
  }, [setLookOpened])

  useEffect(()=> {
    return () => {
      if (abortRequestController) {
        abortRequestController.abort();
      }
      store.dispatch(setMultiLoader({activeStep: 8, visible: false, finished: true}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(()=> {
    // wi will display door styles for this category
    setLookActiveCategory(SHAPE_PART_ID.top_cabinet);

    store.dispatch(setMultiLoader({activeStep: 0, visible: false, finished: false}));
    store.dispatch(setMultiLoader({activeStep: 0, visible: true, finished: false}));

    sqftShapeManager.changeShapesFeatureIDIfColorWasChanged(lookActiveFeature);

    setCabinetdGLBFromCabinetsSet().then(r => void r);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveFeature])

  const closeButtonClick = () => {
    setSQFTAr3dPopup(({isOpened: false, contentType: null}));
  }
  const isGoogleViewer = false;

  return (
    <div className="message-window-base ar-popup">
      <div className="">
        <button className="button--close"
                onClick={() => closeButtonClick()} >
        </button>
      </div>
      <div className="ar-popup__content">
        {isGoogleViewer
          ? <ShapesGoogleModelViewer/>
          : (
            <Fragment>
              {cabinetsGlb && !apiErrorMessage ? <ShapesThreeJsViewer/> : null}
              {apiErrorMessage || <MultiLoader useCabinetLoader={true}/>}
            </Fragment>
          )}
        { !isProd() ? <GroheFeatures/> : null}
      </div>
      <div className="ar-popup__footer">
        <div className={"ar-popup__buttons"}>
          { Config.isDevMode() ? <ExportButton /> : null}
          { !isProd() ? <SqftFeaturesPopupChangeColorButton /> : null}
          <SqftFeaturesPopupSaveImageButton />
          <SqftFeaturesPopup3dButtons />
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  ar3dPopup: store.sqftMenuState.ar3dPopup,
  cabinetsGlb: store.sqftState.cabinetsGlb,
  apiErrorMessage: store.sqftState.apiErrorMessage,
  abortRequestController: store.sqftState.abortRequestController,
  lookActiveFeature: store.lookState.lookActiveFeature,
});

const mapDispatchToProps = {
  setSQFTAr3dPopup,
  setLookActiveCategory,
  setSqftCabinetsGlb,
  setAPIErrorMessage,
  setAbortController,
  setLookOpened,
};


export default connect(mapStateToProps, mapDispatchToProps)(ThreeDContent);
